import { useState, useEffect } from 'react'
import { Logo, FormRow, Alert } from '../components';
import Wrapper from '../assets/wrappers/RegisterPage';
import { useAppContext } from '../context/appContext';
import { useNavigate } from 'react-router-dom'

const initialState = {
    email: '',
    password: '',
}

const Login = () => {
    const navigate = useNavigate();
    const [values, setValues] = useState(initialState);
    const { user, isLoading, showAlert, displayAlert, loginUser } = useAppContext()

    const handleChange = (e) => {
        setValues({ ...values, [e.target.name]: e.target.value })
    }

    const onSubmit = (e) => {
        e.preventDefault();
        const { email, password } = values;
        if (!email && password) {
            displayAlert("Please enter a valid email address");
        } else if (!password && email) {
            displayAlert("Please enter a password");
        } else if (!email && !password) {
            displayAlert("Please enter email and password");
        }
        const currentUser = { email, password }

        loginUser(currentUser);
    }

    useEffect(() => {
        if (user) {
            setTimeout(() => {
                navigate('/')
            }, 2000)
        }
    }, [user, navigate])

    return (
        <Wrapper className='full-page'>
            <form className='form' onSubmit={onSubmit}>
                <Logo />
                <h3>Login</h3>
                {showAlert && <Alert />}
                {/*email input*/}
                <FormRow
                    type="email"
                    name="email"
                    labelText="Email"
                    value={values.email}
                    handleChange={handleChange}
                />
                {/*password input*/}
                <FormRow
                    type="password"
                    name="password"
                    labelText="Passwort"
                    value={values.password}
                    handleChange={handleChange}
                />
                <button type='submit' className='btn btn-block' disabled={isLoading}>
                    Anmelden
                </button>
            </form>
        </Wrapper>);
}

export default Login;